<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:55:48
 * @LastEditTime: 2022-10-20 17:56:31
 * @LastEditors: liushumin
-->
<template>
    <el-main>
        <div class="top-wrap">
            <Bread></Bread>
        </div>
        <div class="main mb0">
            <div class="plate">
                <div class="title2">商品基本信息</div>
            </div>
        </div>
        <div class="main mt0">
            <el-form :model="form" :rules="rules" ref="form0" :inline="true" label-width="110px" class="form-add">
                <el-form-item prop="supplier" class="" label="所属供应商">
                    <el-select v-model="form.supplier" placeholder="请选择供应商" @change="suppliChange">
                        <el-option v-for="item in options" :label="item.name" :value="item.id.toString()">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="brand" class="" label="商品品牌">
                    <el-select v-model.trim="form.brand" placeholder="请选择商品品牌" @change="brandChange">
                        <el-option v-for="item in ppList" :label="item.brandName" :value="item.id.toString()">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="classA" class="" label="商品分类">
                    <el-cascader :options="flList" v-model="form.goodsType" placeholder="请选择商品分类"
                        :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'szEnterpriseInfoList' }"
                        clearable @change="flChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item prop="goodsName" class="" label="商品名称">
                    <el-input placeholder="请填写商品名称" maxlength="30" v-model.trim="form.goodsName"></el-input>
                </el-form-item>
                <el-form-item prop="goodsPoints" class="w100" label="商品卖点">
                    <el-input placeholder="商品详情页显示在商品名称下方，限制30字。" maxlength="30" v-model.trim="form.goodsPoints">
                    </el-input>
                </el-form-item>
                <el-form-item class="w100" label="商品图片" prop="goodsImage">
                    <span class="reds">可拖拽图片调整顺序，最多上传 15 张图</span>
                    <el-upload ref="upload" class="upload-small" :action="'#'" accept="image/jpeg,image/gif,image/png"
                        :multiple="true" :show-file-list="true" list-type="picture-card" :file-list="premisesFileList"
                        :on-preview="handlePreviewImg" :on-remove="(file) => handleRemoveImg(file, 'premises')"
                        :data="{ xtype: 'dv_nz_product', type: 'image' }"
                        :on-success="(file) => handleImgSuccess(file, 'premises')" :http-request="handleCustomUpload"
                        :limit="15">
                        <i class="el-icon-plus"></i>
                        <!-- <template>
                            <div>

                            </div>
                        </template> -->
                    </el-upload>
                </el-form-item>
                <el-form-item label="视频上传" prop="Video">
                    <span class="reds">最多上传1个视频</span>
                    <uploadVideo :videoList="videoList" :fileVideoList="fileVideoList" :videoLimit="videoLimit"
                        @videoUploadSuccess="videoUploadSuccess" :vide="form.goodsVideo" ref="vdo">
                    </uploadVideo>
                </el-form-item>
            </el-form>
            <div class="plate">
                <div class="title">规格与价格</div>
            </div>
            <div class="plate2 spcs">
                <el-form ref="form1" :model="formSku" :rules="rules" label-width="105px">

                    <div class="plate">
                        <!-- <div class="title-bor-left">规格/库存</div> -->
                        <el-form-item label="商品规格：">
                            <el-button type="primary" plain class="btn-addspec" @click="addSpecItem()">添加规格项目
                            </el-button>
                            <span class="grayfs">（规格名：指商品的重量、容量等； 规格值：指不同规格下的商品，如50kg、25kg、200ml、1L等）</span>
                            <div class="spec-list" v-show="specList.length > 0">
                                <div class="item" v-for="(item, index) in specList" :key="index">
                                    <p class="spec-name">
                                        规格名：
                                        <el-input v-model="item.title" placeholder="请输入" @change="specItemChange(item)"
                                            maxlength="20"></el-input>
                                        <span class="icon-close el-icon-error" @click="deleteSpecItem(index)"></span>
                                    </p>
                                    <p class="spec-val">
                                        规格值：
                                        <el-input v-for="(itm, idx) in item.value" :key="idx" v-model="itm.valueName"
                                            maxlength="20" placeholder="请输入" @change="specItemValChange(item, itm)"
                                            @blur="bl(itm, index, idx)">
                                            <el-button slot="append" icon="el-icon-close"
                                                @click="specItemValDel(index, idx)"></el-button>
                                        </el-input>
                                        <el-button type="text" class="btn-add" @click="addSpecItemVal(index)">添加规格值
                                        </el-button>
                                    </p>
                                    <template v-if="index == 0">
                                        <el-upload ref="upload2" class="upload-small" id="speci_upload" :action="'#'"
                                            accept="image/jpeg,image/gif,image/png" :multiple="true"
                                            :show-file-list="true" list-type="picture-card"
                                            :file-list="SpecificationImage" :on-preview="handlePreviewImg"
                                            :on-remove="(file) => handleRemoveImg(file, 'specification')"
                                            :data="{ xtype: 'dv_nz_product', type: 'image' }"
                                            :on-success="(file) => handleImgSuccess(file, 'specification')"
                                            :http-request="handleCustomUpload">
                                            <span v-for="item in SpecificationImage"
                                                v-show="SpecificationImage.length == 0">
                                                <img :src="item.url">
                                            </span>
                                            <i v-show="SpecificationImage.length > 0 || SpecificationImage.length == 0"
                                                class="el-icon-plus"></i>

                                        </el-upload>
                                        <span class="reds ml71">每个规格值可对应一张规格图片，买家选择不同规格会看到对应规格图片，建议尺寸：800 x
                                            800像素</span>
                                    </template>

                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="规格明细：" class="overhidden-form">
                            <table border="0" cellpadding="0" cellspacing="0" class="table-spec">
                                <thead>
                                    <tr>
                                        <th v-for="(item, index) in specListHead" :key="index">{{ item.title }}</th>
                                        <th>单价（元）</th>
                                    </tr>
                                </thead>
                            </table>
                            <div class="table-tree" style="margin-left:-150px;display: inline-block;" v-if="skuActive">
                                <tree-comp v-if="skuList.children.length > 0" ref="treecomp" :treeData="skuList"
                                    :key="treeCompKey"></tree-comp>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-form :model="form" ref="form2" :rules="rules" :inline="true" label-width="110px" class="form-add">
                <el-form-item class="w100" label="价格" prop="jiage">
                    <el-input placeholder="请输入数字" v-model="jiage" oninput="value=value.replace(/[^0-9.]/g,'')"
                        @change="jiageChange" maxlength="8"></el-input>
                </el-form-item>
                <!-- <el-form-item class="w100" label="划线价">
                    <el-input placeholder="请输入数字" v-model="hjx" oninput="value=value.replace(/[^0-9.]/g,'')"
                        maxlength="8"></el-input>
                </el-form-item> -->
                <el-form-item class="w30" label="供货方式" prop="">
                    <el-radio-group v-model="ghfs" @change="radioChe">
                        <el-radio :label="10">现货</el-radio>
                        <el-radio :label="20">非现货</el-radio>
                    </el-radio-group>

                </el-form-item>
                <el-form-item class="w30" label="供货周期" v-show="ghfs == 20">
                    <el-input v-model="ghzq" style="width:120px;" oninput="value=value.replace(/[^0-9.]/g,'')"
                        placeholder="请输入数字" maxlength="4"></el-input>&emsp;天
                </el-form-item>
            </el-form>
            <div class="plate spcs">
                <div class="title">商品参数 <span class="grayfs">（将在商品详情页上方展示给用户）</span> </div>

                <!-- <el-button class="addBtn" @click="addButn"><i class="el-icon-plus"></i> 添加参数</el-button> -->
                <div class="goods-tit">
                    <el-button class="addBtn" @click="addButn"><i class="el-icon-plus"></i> 添加参数</el-button>
                    <span class="grayfs">（例如某尿素化肥的参数：含氮量：≥46.4%，粒度范围：0.85-2.8mm，净含量：50±0.5kg，产地：山东，等级：一等。）</span>
                </div>
                <el-form :model="form" ref="form3" :rules="rules" :inline="true" label-width="110px" class="form-add">
                    <el-form-item class="w100" label=" ">
                        <el-table :data="tableData" style="width: 70vw; margin-top: 10px">
                            <el-table-column prop="name" label="参数项" min-width="8%" align="center">
                                <template slot-scope="{row}">
                                    <div>
                                        <el-input v-model="row.paramName" placeholder="请输入" clearable maxlength="20">
                                        </el-input>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="val" label="参数值" min-width="8%" align="center">
                                <template slot-scope="{row}">
                                    <div>
                                        <el-input v-model="row.paramValue" placeholder="请输入" clearable maxlength="20">
                                        </el-input>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label=" " min-width="8%" align="center">
                                <template slot-scope="{row}">
                                    <div>
                                        <span class="icon-close el-icon-remove" @click="shanchu(row)"></span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-form>
            </div>
            <div class="plate">
                <div class="title">
                    <span class="detail">商品详情</span>
                    <span class="tabs" @click="showText(0)" :class="flag == 0 ? 'actives' : ''">电脑端显示</span>
                    <span class="tabs" style="cursor:not-allowed" :class="flag == 1 ? 'actives' : ''">手机端显示</span>
                </div>
                <el-form :model="form" ref="form4" :inline="true" label-width="110px" class="form-add">
                    <el-form-item label=" " class="w100">
                        <richText v-model="editValue" ref="editor" class="clearfix"></richText>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btm">
                <el-button type="primary" @click="submitForm(20)">保存</el-button>
                <el-button type="primary" @click="formYlan()">预览</el-button>

                <!-- <el-button type="primary" @click="submitForm('form')">预览</el-button> -->
                <el-button type="primary" @click="submitForm(10)">保存并上架</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="previeImgVisible" title="图片预览">
            <div class="previewImg">
                <img class="img" width="100%" :src="previewImgUrl" alt="" />
            </div>
        </el-dialog>
    </el-main>
</template>

<script>
import uploadVideo from "./UploadVideo.vue"
import { uploadImg } from "@/api/uploadImg";
import Sortable from 'sortablejs';
import richText from "./RichText";
import treeComp from './tree2';

export default {
    components: { uploadVideo, richText, treeComp },
    props: [],
    data() {
        var vallidImage = (rule, value, callback, source) => {
            console.log(this.premisesFileList);
            if (this.premisesFileList.length == 0) {
                callback(new Error("商品图片不能为空"));
            } else {
                callback();
            }
        };
        var jiagesa = (rule, value, callback, source) => {
            console.log(this.arrS.length);
            if (!this.jiage) {
                callback(new Error("价格不能为空"));
            } else {
                callback();
            }
        };
        return {
            ids: this.$route.query.ids,

            // 上传视频

            videoList: [],
            fileVideoList: [],
            videoLimit: 1,


            //表单部分 

            form: {
                supplier: "",//所属供应商
                supplierId: "",//所属供应商id
                brand: "",//商品品牌
                brandId: "",//商品品牌id
                goodsType: [],//商品分类
                goodsName: "",//商品名称
                goodsPoints: "",//商品卖点
                goodsImage: [],//商品图片
                goodsVideo: "",//主图视频
                goodsSpecTitle: '',
                goodsProdu: []
            },
            premisesFileList: [], //商品图片
            previewImgUrl: "", //预览图片url
            previeImgVisible: false, //预览图片弹框
            editValue: '', //富文本
            // 表单校验

            rules: {
                supplier: [{
                    required: true,
                    message: "所属供应商不能为空",
                    trigger: "change",
                }],
                brand: {
                    required: true,
                    message: "商品品牌不能为空",
                    trigger: "change",
                },
                classA: {
                    required: true,
                    message: "商品分类不能为空",
                    trigger: "change",
                },
                goodsName: {
                    required: true,
                    message: "商品名称不能为空",
                    trigger: "blur",
                },
                goodsImage: [{
                    required: true,
                    message: "商品图片不能为空",
                    validator: vallidImage,
                    trigger: "change",

                }],
                jiage: {
                    required: true,
                    message: "价格不能为空",
                    validator: jiagesa,
                    trigger: "change",
                },
            },

            //规则与价格

            SpecificationImage: [], //上传规格图片
            specList: [],//规格[{"id":0,"title":"尺寸","value":[{"id":0,"content":""},{}]}]
            specListHead: [],//规格-页面上显示的表头
            skuList: {
                children: [],
            },
            videos: '',
            treeCompKey: 0,

            checked: true,
            jiage: "",
            hjx: "",
            ghfs: 10,
            ghzq: "",
            // tabs 

            flag: 0,
            ppList: [],
            flList: [],

            input: "",
            tableData: [

            ],
            options: [],
            arrS: [],
            arrSS: [],
            //规格
            specListHead: [],
            specList: [],
            formSku: {
                title: "",
                checkedCategory: [],
                image: [],
                status: "10",
                ordering: 0,
                content: "",
            },
            treeCompKey: 0,
            editIniting: false,

            specJson: [],
            specTitleValueJson: [],
            vide: {},
            imgs: [],
            skuActive: false,
            listsData: [],
            videosImg: ''
        };
    },
    mounted() {
        this.initDragSort();
        // var spec_detail = [
        //     {
        //         "id": "191",
        //         "product_id": "5",
        //         "spec_title_id": "20",
        //         "spec_title_name": "重量",
        //         "spec_value_id": "577",
        //         "spec_value_name": "2.5KG",
        //         "level": "1",
        //         "children": [
        //             {
        //                 "id": "192",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "579",
        //                 "spec_value_name": "礼盒装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "193",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "192",
        //                         "price": "66.00",
        //                         "price_underline": "66.30",
        //                         "stock": "666"
        //                     },
        //                     {
        //                         "id": "194",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "192",
        //                         "price": "77.00",
        //                         "price_underline": "77.30",
        //                         "stock": "77"
        //                     },
        //                     {
        //                         "id": "195",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "192",
        //                         "price": "88.00",
        //                         "price_underline": "88.30",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "191"
        //             },
        //             {
        //                 "id": "196",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "580",
        //                 "spec_value_name": "袋装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "197",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "196",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "198",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "196",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "199",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "196",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "191"
        //             }
        //         ],
        //         "parent_id": "0"
        //     },
        //     {
        //         "id": "200",
        //         "product_id": "5",
        //         "spec_title_id": "20",
        //         "spec_title_name": "重量",
        //         "spec_value_id": "578",
        //         "spec_value_name": "5KG",
        //         "level": "1",
        //         "children": [
        //             {
        //                 "id": "201",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "579",
        //                 "spec_value_name": "礼盒装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "202",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "201",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "203",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "201",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "204",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "201",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "200"
        //             },
        //             {
        //                 "id": "205",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "580",
        //                 "spec_value_name": "袋装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "206",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "205",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "207",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "205",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "208",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "205",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "200"
        //             }
        //         ],
        //         "parent_id": "0"
        //     }
        // ]
        // var spec = [
        //     {
        //         "id": "20",
        //         "title": "重量",
        //         "value": [
        //             {
        //                 "id": "577",
        //                 "spec_title_id": "20",
        //                 "content": "2.5KG"
        //             },
        //             {
        //                 "id": "578",
        //                 "spec_title_id": "20",
        //                 "content": "5KG"
        //             }
        //         ]
        //     },
        //     {
        //         "id": "21",
        //         "title": "包装",
        //         "value": [
        //             {
        //                 "id": "579",
        //                 "spec_title_id": "21",
        //                 "content": "礼盒装"
        //             },
        //             {
        //                 "id": "580",
        //                 "spec_title_id": "21",
        //                 "content": "袋装"
        //             }
        //         ]
        //     },
        //     {
        //         "id": "78",
        //         "title": "5555",
        //         "value": [
        //             {
        //                 "id": "581",
        //                 "spec_title_id": "78",
        //                 "content": "6666"
        //             },
        //             {
        //                 "id": "582",
        //                 "spec_title_id": "78",
        //                 "content": "7777"
        //             },
        //             {
        //                 "id": "583",
        //                 "spec_title_id": "78",
        //                 "content": "8888"
        //             }
        //         ]
        //     }
        // ]
        // var resList = [{
        //     skuNames: '白色,100',
        //     productsPrice: 12
        // }, {
        //     skuNames: '白色,200',
        //     productsPrice: 13
        // }]
        var spec_detail = []
        var spec = []
        var resList = []
        this.skuList = { children: spec_detail };

        this.specList = spec;
        console.log("this.skuList", this.skuList)


    },
    computed: {
        specListWatch() {
            return JSON.parse(JSON.stringify(this.specList))
        },
    },
    watch: {
        specListWatch: {
            deep: true,
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                this.treeCompKey += 1;
                let newSpecNames = newVal.filter(item => {
                    if (item.title != '' && item.value.length > 0) {
                        if ((item.value.filter(itm => itm.content != '' || itm.valueName != '')).length > 0) {
                            return item;
                        }
                    }
                });
                console.log(newSpecNames);

                let oldSpecNames = oldVal.filter(item => {
                    if (item.title != '' && item.value.length > 0) {
                        if ((item.value.filter(itm => itm.content != '')).length > 0) {
                            return item;
                        }
                    }
                });
                //过滤掉空的规格值
                let specListHead = [];
                newSpecNames.forEach(item => {
                    let itemNew = { ...item };
                    itemNew.value = item.value.filter(itm => itm.content != '' || itm.valueName != '');
                    specListHead.push(itemNew)
                });
                this.specListHead = specListHead;
                if (this.editIniting) {
                    this.editIniting = false;
                    return false;
                }
                this.handleSpecDatas1();
                this.skuOrdering = true;
                // if (newSpecNames.length != oldSpecNames.length) {
                //     //结构改变-重新排序
                //     this.handleSpecDatas1();
                //     this.skuOrdering = true;
                // } else {
                //     //追加/修改规格值-不重新排序
                //     this.skuOrdering = false;

                // }

            },

        },

    },

    created() {
        this.fn()
        this.pinpai()
        this.spflFn()
        this.get_SupplierList()
    },
    methods: {

        fn() {
            this.$http.orders.detailOrder({ id: this.ids }).then(res => {
                console.log(res);
                let obj = res.data
                res.data.szProductsMediaList.forEach(item => {
                    if (item.flag == 20) {
                        this.vide = item
                    } else if (item.flag == 10) {
                        this.imgs.push(item)
                        this.premisesFileList.push({ url: item.imgUrl })
                    }
                })

                let types = [obj.oneClassId, obj.twoClassId ? obj.twoClassId : '', obj.threeClassId ? obj.threeClassId : '']
                console.log(types)
                types = types.filter(itm => itm != '');

                console.log(types)

                this.form = {
                    supplier: obj.supplierName,//所属供应商
                    supplierId: obj.supplierId,//所属供应商
                    brand: obj.brandName,//商品品牌
                    brandId: obj.brandId,//商品品牌
                    goodsType: types,//商品分类
                    goodsName: obj.productsName,//商品名称
                    goodsPoints: obj.salePoint,//商品卖点
                    goodsImage: obj.mainImgUrl ? obj.mainImgUrl.split() : '',//商品图片
                    goodsVideo: this.vide,//主图视频
                    goodsSpecTitle: obj.spec,
                    goodsSpec: obj.specTitleValue,
                    goodsProdu: obj.szProductsSkuParamsList
                }
                // this.premisesFileList = this.imgs
                this.videosImg = this.vide.url
                this.videos = this.vide.imgUrl
                this.jiage = obj.productsPrice
                this.hjx = obj.markingPrice
                this.ghfs = Number(obj.modeOfSupply)
                this.ghzq = obj.modeOfDay
                this.editValue = obj.productDesc
                this.arrS = this.imgs
                let as = JSON.parse(JSON.stringify(this.form.goodsSpecTitle))
                let as2 = JSON.stringify(this.form.goodsSpecTitle)
                this.specList = JSON.parse(as)

                var objs = {};
                // console.log(this.specList[2].value);
                if (this.specList[2]) {
                    this.specList[2].value = this.specList[2].value.reduce(function (item, next) {
                        console.log(item, 'aaa');
                        console.log(next, 'aaa');
                        objs[next.valueName] ? '' : objs[next.valueName] = true && item.push(next);
                        return item;
                    }, []);
                }
                let arr = JSON.parse(JSON.stringify(this.form.goodsSpec))
                let arr2 = JSON.parse(arr)
                console.log(arr2);
                var sku = this.$sku.sku(arr2);
                var that = this;
                console.log(sku);
                this.$nextTick(function () {
                    that.skuList = { children: sku };
                    that.skuActive = true;
                    console.log('table结构:', that.skuList);
                })
                // this.skuList = { children: this.$sku.sku(arr2) };
                this.tableData = this.form.goodsProdu
                console.log(that.skuList);
                console.log(this.tableData);
                console.log(this.specList);
                this.SpecificationImage = []
                this.specList[0].value.forEach((item, index) => {
                    console.log(item)
                    if (item.titleImageUrl) {
                        this.SpecificationImage.push({ url: item.titleImageUrl })
                    } else if (item.valueImageUrl) {
                        this.SpecificationImage.push({ url: item.valueImageUrl })
                    }
                })
                console.log(this.SpecificationImage);


            })
        },


        // 获取产品详情-修改操作时
        uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            var uuid = s.join("");
            return uuid;
        },


        //提交
        submitForm(val) {
            console.log(this.SpecificationImage)
            // this.$refs.vdo.handleVideoSuccess()
            var imgList = [];
            if (this.SpecificationImage.length > 0) {
                var item = this.SpecificationImage;

                for (var i = 0; i < item.length; i++) {
                    imgList.push(item[i].url)
                }
            }

            var specJson = [];
            var specTitleValueJson = [];
            var item = this.skuList.children;

            var arr = [];
            var arr2 = [];
            var arr3 = [];
            for (var i = 0; i < item.length; i++) { //循环第一级

                var item2 = item[i].children;
                //第一个数组
                arr.push({
                    valueName: item[i].spec_value_name,
                    valueSort: i,
                    valueImageUrl: imgList.length > 0 ? imgList[i] : ''
                })
                if (item2) {
                    for (var j = 0; j < item2.length; j++) { //循环二级				

                        var item3 = item2[j].children;
                        //第二个数组
                        if (i == 0) {
                            arr2.push({
                                valueName: item2[j].spec_value_name,
                                valueSort: j,

                            });
                        }
                        if (item3) {
                            for (var m = 0; m < item3.length; m++) {//循环三级	
                                //第三个数组
                                if (j == 0) {
                                    arr3.push({
                                        valueName: item3[m].spec_value_name,
                                        valueSort: m,

                                    })
                                }
                                specTitleValueJson.push({//标注
                                    valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name + ',' + item3[m].spec_value_name,
                                    price: item3[m].price,
                                    valueSort: i,
                                })
                            }
                        }
                        if (!item3) {
                            specTitleValueJson.push({//标注
                                valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name,
                                price: item2[j].price,
                                valueSort: i,

                            })
                        }

                    }

                }
                if (!item2) {
                    specTitleValueJson.push({//标注
                        valueName: item[i].spec_value_name,
                        price: item[i].price,
                        valueSort: i,

                    })
                }
            }
            for (let i = 0; i < this.specListHead.length; i++) {
                if (i == 0) {
                    specJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr
                    })
                } else if (i == 1) {
                    specJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr2
                    })
                } else if (i == 2) {
                    specJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr3
                    })
                }
            }

            console.log("specTitleValueJson", specTitleValueJson)
            var objs = {};
            console.log(specJson[2]);
            if (specJson[2]) {
                specJson[2].value = specJson[2].value.reduce(function (item, next) {
                    console.log(item, 'aaa');
                    console.log(next, 'aaa');
                    objs[next.valueName] ? '' : objs[next.valueName] = true && item.push(next);
                    return item;
                }, []);
            }
            console.log(this.videos)
            console.log("specJson", JSON.stringify(specJson))

            this.$set(this.form, 'classA', this.form.goodsType)
            this.$set(this.form, 'brand', this.form.brand)
            console.log(this.form.brand)
            console.log(this.form.goodsImage);
            console.log(this.form.goodsType.length)
            let nums = val
            let data = []
            this.tableData.forEach((item, index) => {
                console.log(item)
                data.push({ parmKey: item.paramName, parmValue: item.paramValue })
            })
            console.log(this.arrS);
            let imgs = []
            this.arrS.forEach((item, index) => {
                imgs.push(item.imgUrl || item.url || item)
            })
            console.log(imgs + '');
            console.log(this.form.goodsImag);

            // this.form.goodsImag = imgs[0]
            let obj = {
                id: this.ids,
                brandId: this.form.brandId.toString(),//品牌id	
                enterpriseId: this.form.supplierId.toString(),//供应商id		
                mainSpuImageUrl: imgs[0],//商品主图		
                // mainSpuImageUrl: this.form.goodsImage[0],//商品主图		
                // mainSpuVideoUrl: 'http.ceshi.mp4',//商品视频	
                mainSpuVideoUrl: this.videos,//商品视频	
                // markingPrice: this.hjx,//划线价		
                modeOfDay: this.ghzq || '',//供货周期	
                modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                ordinarySpuImageUrl: imgs + '',//商品普通图	
                parmJson: JSON.stringify(data),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                productDesc: this.editValue,//商品描述PC		
                //  productDescApp: "<p>111</p>",//商品描述App		
                productsName: this.form.goodsName,//spuName
                productsPrice: this.jiage,//商品价格	
                salePoint: this.form.goodsPoints,//卖点
                specJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                specTitleValueJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                status: val,//状态（10:上架;20:下架)	
                threeClassId: this.form.goodsType.length > 2 ? this.form.goodsType[2].toString() : '',//生资三级分类	
                twoClassId: this.form.goodsType.length > 1 ? this.form.goodsType[1].toString() : '',//生资二级分类	
                mainSpuVideoCoverUrl: this.videosImg

            }
            console.log(obj);
            const formName = ['form0', 'form1', 'form2', 'form3']
            const validates = (item) => {
                return new Promise((resolve, reject) => {
                    console.log(this.$refs[item]);
                    if (!this.$refs[item]) {
                        resolve()
                        return false
                    }
                    this.$refs[item].validate((valid) => {
                        if (valid) {
                            resolve()
                        } else {
                            reject(new Error('验证不对'))
                        }
                    })
                })
            }
            Promise.all(formName.map(item => validates(item))).then(() => {


                console.log(obj);
                this.$http.orders.ordersAmend(obj).then(res => {
                    console.log(res)
                    if (res.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.$router.push({ path: './list' })

                    }
                })
            }).catch(() => {
                console.log('失败')
            })
        },
        // 供应商获取

        get_SupplierList() {
            let obj = {
                pageNum: 1,
                pageSize: 999
            }
            this.$http.supplierApi.getSupplierList(obj).then(res => {
                // this.options = res.data.szEnterpriseInfoList
                console.log(res);
                this.options = []
                res.data.szEnterpriseInfoList.forEach(item => {
                    this.options.push({ name: item.enterpriseName, id: item.id })
                })
            })
        },
        radioChe(e) {
            console.log(e);
            this.ghzq = null

        },
        handleSpecDatas1() {
            let arr = [];
            console.log(this.specListHead);
            this.specListHead.forEach(item => {
                if (item.value.length > 0) {
                    let specItemValue = [];
                    item.value.forEach(itm => {
                        if (itm.valueName) {
                            let obj = {
                                // id: itm.id,
                                spec_value_name: itm.valueName,
                                // idx1: itm.idx1,
                                // idx2: itm.idx2,
                                // spec_title_id: itm.spec_title_id ? itm.spec_title_id : null
                            }
                            specItemValue.push(obj)
                        }
                    })
                    arr.push(specItemValue)
                }
            })
            console.log('arr', arr);
            let arr1 = arr.length > 0 ? [...arr[0]] : [];
            arr1.forEach((item, ind) => {
                let idx = 1;
                item = this.handleSpec2(idx, item, arr, ind)
            })
            this.skuList = { children: arr1 };
            console.log('', this.skuList);
        },
        // 添加规格
        addSpecItem() {
            if (this.specList.length > 2) {
                this.$message({
                    message: '最多可添加3条！',
                    type: 'warning'
                });
            } else {
                let idx1 = `${this.specList.length}`;
                let obj = { id: '0', title: "", idx1, value: [] };
                this.specList.push(obj);
            }

            console.log(" this.specList", this.specList)
        },
        // 删除规格
        deleteSpecItem(index) {
            this.specList.splice(index, 1);
            console.log(this.specList)

            // this.$refs.treecomp.fn()
        },
        // 添加规格值
        addSpecItemVal(index) {
            let obj = {};
            let specListItem = this.specList[index];
            let idx1 = index, idx2 = specListItem.value.length > 0 ? (specListItem.value[specListItem.value.length - 1].idx2 + 1) : 0;
            if (specListItem.id && specListItem.id != '0') {//对应的父级规格名有id（修改页面）
                obj = { id: '0', idx1, idx2, spec_title_id: specListItem.id, content: '' };
            } else {
                obj = { id: '0', idx1, idx2, content: '' };
            }
            if (this.specList[index].value.length == 5) {
                this.$message({
                    message: '规格值最多5条',
                    type: 'warning'
                });
            } else {
                // this.specList[index].value.push(obj);
                console.log(specListItem.value[specListItem.value.length - 1]);

                let num = 0
                var arr = [];
                if (this.specList[index].value.length != 0) {
                    if (specListItem.value[specListItem.value.length - 1].content == '' && !specListItem.value[specListItem.value.length - 1].valueName) {
                        this.$message.warning('规格值不能为空')
                    } else {
                        this.specList[index].value.push(obj);
                    }
                } else {
                    this.specList[index].value.push(obj);

                }

            }
        },
        //删除规格值
        specItemValDel(index1, index2) {
            let item = this.specList[index1].value[index2];
            item.isDel = true;
            this.handleSpecValues(this.skuList.children, item);
            this.specList[index1].value.splice(index2, 1);
        },
        // 规格名改变-输入事件
        specItemChange(item) {
            console.log(item);
            if (item.value && item.value.length > 0) {
                // item.value = [];
            }
        },
        // 规格值改变-输入事件
        specItemValChange(item, itm) {

            console.log("item", item)
            console.log("itm", itm)
            console.log('specList', this.specList);
            // if () {

            // }
            // if (!this.skuOrdering) {
            this.handleSpecValues(this.skuList.children, itm)
            console.log(this.skuList)
            // }
            // console.log(this.skuList)
        },
        pinpai() {
            let obj = {
                pageNum: 1,
                pageSize: 1000
            }
            this.$http.brandApi.getBrandList(obj).then(res => {
                console.log(res)
                this.ppList = res.data.szProductsBrandList
            })
        },
        bl(itm, val, val2) {
            console.log(itm)
            console.log(val)
            console.log(val2)
            console.log(this.specList[val].value)
            let sss = []
            if (this.specList[val].value.length > 1) {
                this.specList[val].value.filter((item, index) => {
                    if (index != val2) {
                        sss.push(item)
                    }
                })
            }
            console.log(sss);
            sss.forEach((item, index) => {
                if (item.valueName == itm.valueName) {
                    this.$message.warning('规格值不能重复')
                    let item = this.specList[val].value[val2];
                    item.isDel = true;
                    this.handleSpecValues(this.skuList.children, item);
                    this.specList[val].value.splice(val2, 1);
                }
            })
        },
        spflFn() {
            this.$http.orders.ordersClass().then(res => {
                console.log(res)
                this.flList = res.data
            })
        },
        handleSpecValues(arr, itm, arr2) {
            let isEdit = false;
            console.log(arr);
            arr.forEach((item, index) => {
                if (arr2) {
                    let obj = {
                        id: '0',
                        spec_value_name: item.spec_value_name,
                        idx1: item.idx1,
                        idx2: item.idx2,
                        spec_title_id: item.spec_title_id
                    }
                    if (!item.children || item.children == '-10') {
                        obj.price = 0;
                        obj.price_underline = 0;
                        obj.stock = 0;
                    } else {
                        obj.children = [];
                    }
                    arr2.push(obj);
                    if (item.children && item.children != '-10') {
                        this.handleSpecValues(item.children, itm, arr[arr.length - 1].children)
                    }
                } else {

                    if (((item.idx1 || item.idx1 === 0) && item.idx1 == itm.idx1) || (itm.spec_title_id && (item.spec_title_id == itm.spec_title_id))) {
                        //一级相等
                        if (((item.idx2 || item.idx2 === 0) && item.idx2 == itm.idx2) || (item.spec_value_id && item.spec_value_id == itm.id)) {
                            console.log("修改规格值", itm, item)
                            //修改规格值
                            if (itm.content == '' || itm.isDel) {
                                //填写的规格值内容为空或删除规格值操作时
                                arr.splice(index, 1);
                                console.log('填写的规格值内容为空或删除规格值操作', arr)
                            } else {
                                item.spec_value_name = itm.content;
                            }
                            isEdit = true;
                        } else if (index == arr.length - 1 && !isEdit) {
                            if (itm.isDel) {
                                console.log('删除规格值', arr)
                                arr.splice(itm.idx2, 1); return false;
                            }
                            //追加规格值
                            let obj = {
                                id: '0',
                                spec_value_name: itm.content,
                                idx1: itm.idx1,
                                idx2: itm.idx2,
                                spec_title_id: itm.spec_title_id
                            };
                            if (!item.children || item.children == '-10') {
                                obj.price = 0;
                                obj.price_underline = 0;
                                obj.stock = 0;
                            } else {
                                obj.children = [];
                            }
                            arr.push(obj);
                            if (item.children && item.children != '-10') {
                                this.handleSpecValues(item.children, itm, arr[arr.length - 1].children)
                            }
                        }
                    } else {
                        console.log("一级不相等")
                        // 一级不相等
                        if (item.children && item.children != '-10') {
                            this.handleSpecValues(item.children, itm)
                        }
                    }
                }
            })
        },
        flChange(val) {
            console.log(val.toString());
            this.form.goodsType = val
            this.$set(this.form, 'classA', val)
        },
        handleSpec2(idx, item, arr, ind = 0, name = "") {
            if (idx < arr.length) {
                item.children = JSON.parse(JSON.stringify(arr[idx]));
                ++idx;
                item.children.forEach((itm, idx2) => {
                    let lowerTitles = arr[arr.length - 1].map(itm2 => itm2.spec_value_name);
                    if (lowerTitles.includes(itm.spec_value_name)) {
                        itm.price = 0;
                        itm.price_underline = 0;
                        itm.stock = 0;
                    }
                    this.handleSpec2(idx, itm, arr, ind, item.spec_value_name)
                })
            } else {
                console.log(idx, item, arr, ind, name);
                console.log(this.skuList.children[ind])
                let firstItem = this.skuList.children[ind];
                let truePrice = 0;
                if (firstItem && idx === 1) {
                    truePrice = firstItem.price || 0;
                } else if (firstItem && idx === 2) {
                    let parent1 = this.skuList.children[ind].children.find(e => e.spec_value_name === item.spec_value_name);
                    if (parent1) {
                        truePrice = parent1.price || 0;
                    }
                } else if (firstItem && idx == 3) {
                    let parent1 = this.skuList.children[ind].children.find(e => e.spec_value_name === name);
                    console.log(parent1)
                    if (parent1) {
                        let parent2 = parent1.children.find(e => e.spec_value_name === item.spec_value_name);
                        if (parent2) {
                            truePrice = parent2.price || 0;
                        }
                    }
                }
                item.price = truePrice;
                item.price_underline = 0;
                item.stock = 0;
            }
            return item;
        },
        // tabs

        showText(val) {
            this.flag = val
        },
        brandChange(val) {
            console.log(val)
            this.form.brandId = val
        },
        suppliChange(val) {
            console.log(val)
            this.form.supplierId = val
        },

        //实现图片拖拽排序

        initDragSort() {
            // 支持拖拽排序
            console.log(this.$refs.upload);
            const el = this.$refs.upload.$el.querySelectorAll('.el-upload-list')[0];
            Sortable.create(el, {
                onEnd: ({ oldIndex, newIndex }) => {
                    // 交换位置
                    const arr = this.premisesFileList;
                    console.log(this.premisesFileList);
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);
                    // this.arrS = arr
                    this.arrS = []
                    arr.forEach(item => {
                        this.arrS.push(item.url)
                    })
                    console.log(this.arrS);
                    this.form.goodsImage = this.arrS[0]
                }
            });
        },
        videoUploadSuccess(file) {
            console.log(file);
            this.videos = file.url;
            this.videosImg = file.thumb
        },

        //图片上传成功

        handleImgSuccess(file, type) {
            switch (type) {
                case "premises":
                    this.premisesFileList.push({ url: file.url, name: file.title });
                    this.arrS = []

                    this.premisesFileList.forEach(item => {
                        this.arrS.push(item.url)
                        this.arrSS.push(item.url)
                    })
                    console.log(this.arrS);
                    // console.log(JSON.stringify(this.arrS).slice(1, JSON.stringify(this.arrS).length - 1));
                    // const formName = ['form0', 'form1', 'form2', 'form3']
                    // const validates = (item) => {
                    //     return new Promise((resolve, reject) => {
                    //         console.log(this.$refs[item]);
                    //         if (!this.$refs[item]) {
                    //             resolve()
                    //             return false
                    //         }
                    //         this.$refs[item].validate((valid) => {
                    //             if (valid) {
                    //                 resolve()
                    //             } else {
                    //                 reject(new Error('验证不对'))
                    //             }
                    //         })
                    //     })
                    // }
                    // Promise.all(formName.map(item => validates(item))).then(() => {
                    //     console.log('成功')
                    //     let obj = {
                    //         brandId: this.form.brand,//品牌id	
                    //         enterpriseId: this.form.supplier,//供应商id		
                    //         mainSpuImageUrl: this.arrS[0],//商品主图		
                    //         // mainSpuVideoUrl: 'http.ceshi.mp4',//商品视频	
                    //         mainSpuVideoUrl: this.videos,//商品视频	
                    //         markingPrice: this.hjx,//划线价		
                    //         modeOfDay: this.ghzq,//供货周期	
                    //         modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                    //         // oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                    //         ordinarySpuImageUrl: JSON.stringify(this.arrS).slice(1, JSON.stringify(this.arrS).length - 1),//商品普通图	
                    //         parmJson: JSON.stringify(this.tableData),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                    //         productDesc: this.editValue,//商品描述PC		
                    //         //  productDescApp: "<p>111</p>",//商品描述App		
                    //         productsName: this.form.goodsName,//spuName
                    //         productsPrice: this.jiage,//商品价格	
                    //         salePoint: this.form.goodsPoints,//卖点
                    //         specJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                    //         specTitleValueJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                    //         status: 20,//状态（10:上架;20:下架)	
                    //         // threeClassId: this.form.goodsType.length > 2 ? this.form.goodsType[2].toString() : '',//生资三级分类	
                    //         // twoClassId: this.form.goodsType.length > 1 ? this.form.goodsType[1].toString() : '',//生资二级分类	

                    //     }
                    //     // this.$set(this.form, 'classA', this.form.goodsType)

                    // }).catch(() => {
                    //     console.log('失败')
                    // })
                    console.log(this.SpecificationImage)
                    // this.$refs.vdo.handleVideoSuccess()
                    var imgList = [];
                    if (this.SpecificationImage.length > 0) {
                        var item = this.SpecificationImage;

                        for (var i = 0; i < item.length; i++) {
                            imgList.push(item[i].url)
                        }
                    }

                    var specJson = [];
                    var specTitleValueJson = [];
                    var item = this.skuList.children;

                    var arr = [];
                    var arr2 = [];
                    var arr3 = [];
                    for (var i = 0; i < item.length; i++) { //循环第一级

                        var item2 = item[i].children;
                        //第一个数组
                        arr.push({
                            valueName: item[i].spec_value_name,
                            valueSort: i,
                            valueImageUrl: imgList.length > 0 ? imgList[i] : ''
                        })
                        if (item2) {
                            for (var j = 0; j < item2.length; j++) { //循环二级				

                                var item3 = item2[j].children;
                                //第二个数组
                                if (i == 0) {
                                    arr2.push({
                                        valueName: item2[j].spec_value_name,
                                        valueSort: j,

                                    });
                                }
                                if (item3) {
                                    for (var m = 0; m < item3.length; m++) {//循环三级	
                                        //第三个数组
                                        if (j == 0) {
                                            arr3.push({
                                                valueName: item3[m].spec_value_name,
                                                valueSort: m,

                                            })
                                        }
                                        specTitleValueJson.push({//标注
                                            valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name + ',' + item3[m].spec_value_name,
                                            price: item3[m].price,
                                            valueSort: i,
                                        })
                                    }
                                }
                                if (!item3) {
                                    specTitleValueJson.push({//标注
                                        valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name,
                                        price: item2[j].price,
                                        valueSort: i,

                                    })
                                }

                            }

                        }
                        if (!item2) {
                            specTitleValueJson.push({//标注
                                valueName: item[i].spec_value_name,
                                price: item[i].price,
                                valueSort: i,

                            })
                        }
                    }
                    for (let i = 0; i < this.specListHead.length; i++) {
                        if (i == 0) {
                            specJson.push({
                                title: this.specListHead[i].title,
                                titleSort: i,
                                value: arr
                            })
                        } else if (i == 1) {
                            specJson.push({
                                title: this.specListHead[i].title,
                                titleSort: i,
                                value: arr2
                            })
                        } else if (i == 2) {
                            specJson.push({
                                title: this.specListHead[i].title,
                                titleSort: i,
                                value: arr3
                            })
                        }
                    }

                    console.log("specTitleValueJson", specTitleValueJson)
                    var objs = {};
                    console.log(specJson[2]);
                    if (specJson[2]) {
                        specJson[2].value = specJson[2].value.reduce(function (item, next) {
                            console.log(item, 'aaa');
                            console.log(next, 'aaa');
                            objs[next.valueName] ? '' : objs[next.valueName] = true && item.push(next);
                            return item;
                        }, []);
                    }
                    console.log(this.videos)
                    console.log("specJson", JSON.stringify(specJson))

                    this.$set(this.form, 'classA', this.form.goodsType)
                    this.$set(this.form, 'brand', this.form.brand)
                    console.log(this.form.brand)
                    console.log(this.form.goodsImage);
                    console.log(this.form.goodsType.length)
                    // let nums = val
                    let data = []
                    this.tableData.forEach((item, index) => {
                        console.log(item)
                        data.push({ parmKey: item.paramName, parmValue: item.paramValue })
                    })
                    console.log(this.arrS);
                    let imgs = []
                    this.arrS.forEach((item, index) => {
                        imgs.push(item.imgUrl || item.url || item)
                    })
                    console.log(imgs + '');
                    // console.log(this.form.goodsImag);

                    // this.form.goodsImag = imgs[0]
                    let obj = {
                        id: this.ids,
                        brandId: this.form.brandId.toString(),//品牌id	
                        enterpriseId: this.form.supplierId.toString(),//供应商id		
                        mainSpuImageUrl: imgs[0],//商品主图		
                        // mainSpuImageUrl: this.form.goodsImage[0],//商品主图		
                        // mainSpuVideoUrl: 'http.ceshi.mp4',//商品视频	
                        mainSpuVideoUrl: this.videos,//商品视频	
                        // markingPrice: this.hjx,//划线价		
                        modeOfDay: this.ghzq || '',//供货周期	
                        modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                        oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                        ordinarySpuImageUrl: imgs + '',//商品普通图	
                        parmJson: JSON.stringify(data),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                        productDesc: this.editValue,//商品描述PC		
                        //  productDescApp: "<p>111</p>",//商品描述App		
                        productsName: this.form.goodsName,//spuName
                        productsPrice: this.jiage,//商品价格	
                        salePoint: this.form.goodsPoints,//卖点
                        specJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                        specTitleValueJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                        // status: val,//状态（10:上架;20:下架)	
                        threeClassId: this.form.goodsType.length > 2 ? this.form.goodsType[2].toString() : '',//生资三级分类	
                        twoClassId: this.form.goodsType.length > 1 ? this.form.goodsType[1].toString() : '',//生资二级分类	
                        mainSpuVideoCoverUrl: this.videosImg

                    }
                    console.log(obj);
                    const formName = ['form0', 'form1', 'form2', 'form3']
                    const validates = (item) => {
                        return new Promise((resolve, reject) => {
                            console.log(this.$refs[item]);
                            if (!this.$refs[item]) {
                                resolve()
                                return false
                            }
                            this.$refs[item].validate((valid) => {
                                if (valid) {
                                    resolve()
                                } else {
                                    reject(new Error('验证不对'))
                                }
                            })
                        })
                    }
                    Promise.all(formName.map(item => validates(item))).then(() => {


                        // console.log(obj);
                        // this.$http.orders.ordersAmend(obj).then(res => {
                        //     console.log(res)
                        //     if (res.status) {
                        //         this.$message({
                        //             message: '操作成功',
                        //             type: 'success'
                        //         });
                        //         this.$router.push({ path: './list' })

                        //     }
                        // })
                    }).catch(() => {
                        console.log('失败')
                    })
                    break;
                case "specification":
                    this.SpecificationImage.push({ url: file.url, name: file.title });
                    break;
                case "videoOne":
                    this.fileVideoList.push({ url: file.url, name: file.title });
                    break;
            }

        },
        addButn(val) {

            this.tableData.push({ id: this.uuid(), parmKey: "", parmValue: "" })
            this.tableData.forEach((item, index) => {
                return item + ''
            })
            console.log(this.tableData)
        },
        jiageChange(val) {
            this.$set(this.jiage, 'jiage', val)
            this.jiage = val
        },
        shanchu(val) {
            this.tableData.splice(this.tableData.findIndex(item => item.id === val.id), 1)
        },
        // 删除图片

        handleRemoveImg(file, type) {
            switch (type) {
                case "premises":
                    this.premisesFileList.forEach((item, index) => {
                        if (item.url == file.url) {
                            this.premisesFileList.splice(index, 1)
                        }
                    })
                    this.arrS = []
                    this.premisesFileList.forEach(item => {
                        this.arrS.push(item.url)
                    })
                    // this.arrSS = []
                    // this.arrS.forEach((item, index) => {
                    //     this.arrSS.push(item.imgUrl)
                    // })

                    // console.log(this.premisesFileList);
                    // this.arrS = JSON.stringify(this.arrSS).slice(1, JSON.stringify(this.arrSS).length - 1)
                    console.log(this.arrS);

                    break;
                case "specification":
                    // this.SpecificationImage = this.SpecificationImage.map(
                    //     (item) => item.url != file.url
                    // );
                    console.log(this.SpecificationImage)
                    this.SpecificationImage.forEach((item, index) => {
                        if (item.url == file.url) {
                            this.SpecificationImage.splice(index, 1)
                        }
                    })
                    break;
            }
        },

        //预览图片

        handlePreviewImg(file) {
            this.previewImgUrl = file.response ? file.response.url : file.url;
            this.previeImgVisible = true;
        },

        //自定义上传

        handleCustomUpload(content) {
            uploadImg(content)
                .then((res) => {
                    content.onSuccess(res.data);
                })
                .catch((err) => {
                    content.onError(err);
                });
        },
        formYlan() {
            console.log(this.SpecificationImage)
            var imgList = [];
            if (this.SpecificationImage.length > 0) {
                var item = this.SpecificationImage;
                for (var i = 0; i < item.length; i++) {
                    imgList.push(item[i].url)
                }
            }
            console.log(imgList);
            var specJson = [];
            var specTitleValueJson = [];
            var item = this.skuList.children;

            var arr = [];
            var arr2 = [];
            var arr3 = [];
            for (var i = 0; i < item.length; i++) { //循环第一级

                var item2 = item[i].children;
                //第一个数组
                arr.push({
                    valueName: item[i].spec_value_name,
                    valueSort: i,
                    titleImageUrl: imgList.length > 0 ? imgList[i] : ''
                })
                if (item2) {
                    for (var j = 0; j < item2.length; j++) { //循环二级				
                        var item3 = item2[j].children;
                        //第二个数组
                        if (i == 0) {
                            arr2.push({
                                valueName: item2[j].spec_value_name,
                                valueSort: j,
                            });
                        }
                        if (item3) {
                            for (var m = 0; m < item3.length; m++) { //循环三级	
                                //第三个数组
                                console.log(item3[m])
                                if (j == 0 && i == 0) {
                                    arr3.push({
                                        valueName: item3[m].spec_value_name,
                                        valueSort: m,
                                    })
                                }
                                specJson.push({

                                    valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name + ',' + item3[m].spec_value_name,
                                    price: item3[m].price,
                                    valueSort: i
                                })
                            }
                        }
                        if (!item3) {
                            specJson.push({
                                valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name,
                                price: item2[j].price,
                                valueSort: i

                            })
                        }

                    }

                }
                if (!item2) {
                    specJson.push({
                        valueName: item[i].spec_value_name,
                        price: item[i].price,
                        valueSort: i

                    })
                }
            }
            for (let i = 0; i < this.specListHead.length; i++) {
                if (i == 0) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr,
                        titleImageUrl: ''
                    })
                } else if (i == 1) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr2
                    })
                } else if (i == 2) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr3
                    })
                }
            }

            console.log("specTitleValueJson", specTitleValueJson)
            console.log("specJson", JSON.stringify(specJson))
            console.log(this.videos)
            let imgs = []
            this.arrS.forEach((item, index) => {
                imgs.push(item.imgUrl || item.url || item)
            })
            console.log(imgs + '');
            const formName = ['form0', 'form1', 'form2', 'form3']
            const validates = (item) => {
                return new Promise((resolve, reject) => {
                    console.log(this.$refs[item]);
                    if (!this.$refs[item]) {
                        resolve()
                        return false
                    }
                    this.$refs[item].validate((valid) => {
                        if (valid) {
                            resolve()
                        } else {
                            reject(new Error('验证不对'))
                        }
                    })
                })
            }
            console.log(this.arrS);

            let obj = {
                brandId: this.form.brand,//品牌id	
                enterpriseId: this.form.supplier,//供应商id		
                mainSpuImageUrl: this.arrS[0],//商品主图		
                mainSpuVideoUrl: this.videos,//商品视频	
                // markingPrice: this.hjx,//划线价		
                modeOfDay: this.ghzq || '',//供货周期	
                modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                ordinarySpuImageUrl: imgs + '',//商品普通图	
                parmJson: JSON.stringify(this.tableData),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                productDesc: this.editValue,//商品描述PC		
                productsName: this.form.goodsName,//spuName
                productsPrice: this.jiage,//商品价格	
                salePoint: this.form.goodsPoints,//卖点
                specTitleValueJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                specJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                threeClassId: this.form.goodsType.length > 2 ? this.form.goodsType[2].toString() : '',//生资三级分类	
                twoClassId: this.form.goodsType.length > 1 ? this.form.goodsType[1].toString() : '',//生资二级分类	
                mainSpuVideoCoverUrl: this.videosImg
            }
            window.localStorage.setItem('obj', JSON.stringify(obj))
            console.log(this.form.supplierId.toString());
            this.$http.supplierApi.getSupplierDetail({ id: this.form.supplierId.toString() }).then((res) => {
                console.log(res.data)
                let supper = ''
                let data = res.data
                let logo = {}
                data.szProductsMediaList.forEach((item, index) => {
                    if (item.types == 30) {
                        logo = item.imgUrl
                    }

                })
                supper = {
                    addr: data.addr,
                    enterpriseName: data.enterpriseName,
                    registAddr: data.registAddr,
                    scopes: data.scopes,
                    logo: logo
                }
                console.log(supper)
                window.localStorage.setItem('supper', JSON.stringify(supper))

            })

            let routedata = this.$router.resolve({
                path: "./Preview",
            });
            window.open(routedata.href, '_blank');
        },
        lists() {
            let obj = {
                pageNum: 1,
                pageSize: 10,
            }

            this.$http.orders.commodityList(obj).then(res => {
                this.listsData = res.data.szProductsSpuList
                console.log(this.listsData[0].id);
            })
            setTimeout(() => {
                let routedata = this.$router.resolve({
                    path: "./Preview",
                    query: {
                        id: this.listsData[0].id
                    }
                });
                window.open(routedata.href, '_blank');
            }, 100)

        }
    },
};
</script>
<style lang='scss' scoped>
.plate {
    .title {
        position: relative;
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-weight: bold;

        label {
            font-size: 16px;
            color: #999999;
        }

        &:before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 18px;
            background: #018388;
            border-radius: 3px;
            margin-right: 5px;
        }
    }

    .title2 {
        font-size: 18px;
        color: #018388;
        display: flex;
        align-items: center;
        font-weight: bold;

        label {
            font-size: 16px;
            color: #999999;
        }

        // &:before {
        //     content: "";
        //     display: inline-block;
        //     width: 5px;
        //     height: 18px;
        //     background: #018388;
        //     border-radius: 3px;
        //     margin-right: 5px;
        // }
    }
}

.el-form-item {
    position: relative;
    /* 
    width: 600px; */

    .el-input,
    .el-select,
    .el-cascader {
        width: 340px;
    }

    &.w100 {
        width: 100%;
    }

    &.w30 {
        width: 308px;
    }

    &.w82 {
        width: 800px;
        // width: calc(100% - 682px);
    }
}

.grayfs {
    font-size: 15px;
    color: #666666;
    font-weight: 400;

}

.commodity_type {
    width: calc(70vw - 20px);
    padding: 13px 10px;
    border: 1px solid #e8e8e8;

    .ggz_div {

        .p1 {
            position: relative;
            padding: 10px;
            width: 98%;
            height: 40px;
            background-color: #F1F5F8;

            .el-checkbox {
                margin-left: 20px;
            }



            .el-input {
                width: 200px;
                margin-left: 10px;
            }
        }

        .p2 {
            padding: 10px;
            width: 98%;
            // height: 40px;

            .add_spe {
                color: #018388;
                margin-left: 10px;
                cursor: pointer;
            }

            .el-input {
                width: 180px;
                // margin-left: 10px;
            }

            .ggz {
                display: inline;
            }
        }
    }
}

.table_header {
    list-style: none;
    width: 70vw;
    display: flex;

    li {
        flex: 1;
        border: 1px solid #ccc;
        text-align: center;
    }
}

.table_body {
    list-style: none;
    width: 70vw;

    display: flex;
    flex-direction: column;

    li {
        flex: 1;
        border: 1px solid #ccc;
        text-align: center;
    }
}

.reds {
    color: #F61222;
    font-size: 14px;
}

.ml9 {
    margin-left: 9px;

}



.cur {
    cursor: pointer;
}

.ml71 {
    margin-left: 46px;
}

#speci_upload {
    margin-left: 46px !important;
}

.clearfix {
    height: 80%;
    min-height: 160px;
    width: 70vw;
}

::v-deep .el-tabs__content {
    min-height: 200px;
}

.mb0 {
    margin-bottom: 0;
    border-bottom: 1px solid #E9EBEE;
}

::v-deep .mt0 {
    margin-top: 0 !important;
}

::v-deep .btn .el-icon-plus {
    margin-left: -14px;
}

.ggm {
    font-size: 16px;
    color: #333333;
}

.ggz {
    font-size: 16px;
    color: #333333;
}

::v-deep .el-input--mini .el-input__inner {
    width: 180px;
}

.p3 {
    margin-left: 17px;
}

.el-icon-close:before {
    content: "\e6db";
    background-color: #018388;
    border-radius: 50%;
    padding: 2px;
    color: #fff;
    display: inline-block;
    width: 14px;
    height: 14px;
    font-size: 10px;
    line-height: 16px;
    position: absolute;
    top: 11px;
    right: 2px;
}

::v-deep .el-icon-error {
    color: #FF0000;
}

::v-deep .el-icon-remove:before {
    content: "\e7a2";
    color: red;
}

::v-deep .spcs .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
    width: 70vw;
}

.el-form-item__content {
    overflow: hidden;
}

.bigrem {
    font-size: 24px;
    cursor: pointer;
}

::v-deep .el-table .el-table__body {
    font-size: 24px;
    cursor: pointer;

}

.addBtn {
    color: #018388;
    // position: absolute;
    // left: 69vw;
    float: left;
    margin-left: 110px;

    i {
        font-weight: 500;
    }

    border:1px solid;
}

.tabs {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #018388;
    cursor: pointer;
}

.detail {
    margin-right: 29px;
}

.actives {
    background: #018388;
    color: #fff;
}

.btm {
    width: 100%;
    // height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-button {
        width: 120px;

    }
}

.plate2 {
    .title-bor-left {
        margin-bottom: 15px;
    }

    .tip-txt {
        font-size: 16px;
        color: #cbcbcb;
    }

    .btn-addspec {
        font-size: 16px;
        padding: 11px;
    }

    .spec-list {
        border: 1px solid #E8E8E8;
        padding: 12px;
        margin-top: 10px;
        font-size: 16px;
        color: #323333;

        .spec-name {
            background: #F1F5F8;
            padding: 10px;
            position: relative;

            .el-input {
                width: 160px;
            }

            .icon-close {
                cursor: pointer;
                font-size: 28px;
                opacity: 0.5;
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .spec-val {
            padding: 10px;

            .el-input {
                width: 160px;
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }
    }

    .plate {
        .el-form-item__content {
            overflow: hidden !important;
        }
    }

    .table-spec {
        // width: 100%;
        border: 1px solid #E8E8E8;

        thead {
            background: #F7F7F7;
            height: 54px;

            .star {
                color: #EE0000;
            }
        }

        th,
        td {
            font-size: 16px;
            color: #323333;
            font-weight: normal;
            text-align: center;
            width: 150px;
            box-sizing: border-box;
        }

        // .el-input{
        // 	width: 80%;
        // 	margin: 10px 0;
        // }
    }

    .icon-close {
        cursor: pointer;
        font-size: 28px;
        position: absolute;
        right: 10px;
        top: 50%;
        opacity: 1 !important;
        transform: translateY(-50%);
    }
}

.layout .el-container .el-main {
    overflow-x: clip;
}

.table-tree {
    position: relative;
}

.overhidden-form .el-form-item__content {
    overflow: hidden !important;
}

::v-deep img {
    border: 0;
    vertical-align: middle;
    overflow: hidden;
    height: 100%;
    width: 100%;
}

::v-deep video {
    width: 122px;
    height: 124px;
}

.goods-tit {
    display: flex;
    align-items: center;
}
</style>

